/* Fiber Upsell Custom v1.11.0 — compre-junto (PDP) + modal pós-add.
   v1.11.0 — (a) cards do aviso de calce renomeados: "Sua numeração" (mais espaço frontal) x
   "Numeração menor" (mais ajustado); (b) compre-junto mostra o preço UNITÁRIO já com o % do
   combo aplicado (âncora e itens marcados, com preço cheio riscado) — antes só o total refletia
   o cupom e o preço da âncora parecia sem desconto.
   Motor reco (compre-junto): fiberreco (híbrido co-compra+semântico). Substitui Assortion.
   Modal pós-add: EXCLUSIVO da oferta Octo MaxGrip Clear. Sem cupom; v1.5.0: layout alinhado ao
   popup padrão do tema (fiber-popup) — mídia full-width no topo, close circular, corpo centralizado.
   v1.6.1 — CUPOM DO COMBO: no MÁXIMO um CJ por carrinho, com upgrade de faixa. Os códigos CJ10-/CJ14- são
   'off order' combináveis entre si, então cada combo novo empilhava outro cupom sobre TODO o
   pedido (pedido #367051: CJ14+CJ10+CJ10 = 34% de desconto, inclusive num tênis que não era
   de combo). Agora o carrinho é lido ANTES de aplicar, o apply é CONFIRMADO no /cart.js depois
   (o /discount/<code> responde 200 mesmo quando não aplica) e a falha é reportada em vez de
   engolida num catch vazio. Se o novo combo dá uma faixa MAIOR (14% > 10%), o CJ antigo é
   removido antes (POST /cart/update.js {discount:''}) para trocar sem somar. Cupom que NÃO é
   de combo (afiliado, FIBER15, etc.) é intocável: nesse caso o CJ simplesmente não entra.
   Oferta Octo: o preço da variante já é o promocional; compare_at_price = valor cheio riscado,
   % OFF dinâmico. Não abre se a Clear já está no carrinho, se o produto adicionado
   é o próprio Octo, se não há compare_at > preço, ou 1x por sessão.
   v1.7.0 — AVISO DE CALCE (FIT_NOTICES): produto mapeado por id abre, no add-to-cart, um popup
   informativo de ajuste em vez do upsell — os dois modais no mesmo clique se atropelavam.
   v1.8.0 — o aviso virou GATE PRÉ-ADD: o clique em "Adicionar ao carrinho" é interceptado na fase
   de captura, o aviso aparece e o add só acontece quando a pessoa confirma no popup. Confirmado o
   add (variant:add), grava ok em localStorage e o aviso nunca mais aparece p/ aquele produto;
   fechar no ✕/Esc não grava. Registro central window.FiberModals (compartilhado com fiber-popup.js)
   garante UM popup por vez: gate(30) > upsell(20) > boas-vindas(10).
   v1.9.0 — o aviso virou COMPARATIVO: duas fotos (pé com folga x pé ajustado) e os dois caminhos
   explícitos — continuar no número escolhido ou trocar para um abaixo, com o seletor da página
   sendo marcado de verdade (fallback: add direto da variante menor). Número menor esgotado na cor
   escolhida esconde a opção e avisa. v1.9.1 — catálogo do produto é pré-carregado no load da PDP,
   com cache e 1 retry: a chamada feita no instante do clique voltava 429 e o popup abria sem os
   números. Falhando mesmo assim, o popup continua funcional com nota orientando a troca manual.
   v1.9.2 — as duas fotos estavam trocadas: a com folga é a que tem a linha rente à ponta dos dedos
   (arquivos -v3 na Shopify, nomeados pela situação que ilustram).
   v1.10.0 — alinhado ao critério de aceite da task do Notion (pop-up de confirmação de tamanho):
   checkbox obrigatório "Li e confirmo o tamanho que escolhi" travando o CTA, botão "Quero trocar o
   tamanho" que NÃO adiciona e devolve o foco ao seletor de numeração, frequência 1x por SESSÃO
   (sessionStorage, era localStorage permanente) e os 3 eventos exigidos: fiber_size_modal_shown,
   fiber_size_confirmed e fiber_size_change_requested (dataLayer + gtag + CustomEvent).
   Atribuição: line property _reco_source em todo add originado aqui. */
(function () {
  'use strict';
  var API = 'https://fiberreco.rafaeltondin.com.br/api/related/';
  var FETCH_TIMEOUT = 8000;
  var internalAdd = false; // evita modal pós-add disparar para adds dos próprios widgets
  // Cupons do combo. ATENÇÃO: no Shopify esses códigos estão como desconto de PEDIDO
  // ('across'/'all'), combináveis entre si — por isso o apply passa obrigatoriamente por
  // applyComboCoupon(), que impede mais de um CJ por carrinho. dyn+productId = código
  // dinâmico por âncora (mensuração por combo); `code` estático é legado (não usado).
  var COMBO_CUPONS = { 1: { code: 'COMPREJUNTO10', dyn: 'CJ10-', pct: 0.10 }, 2: { code: 'COMPREJUNTO14', dyn: 'CJ14-', pct: 0.14 } };
  // Oferta do modal pós-add: Octo MaxGrip Clear.
  // Sem cupom: o preço da variante já é o promocional (47,94) e o compare_at_price
  // da Shopify traz o "valor cheio" riscado — % OFF calculado dinamicamente.
  var OCTO = {
    pid: 8654549123289,
    variantId: 45922404663513,
    handle: 'octo-max-grip',
    capKey: 'fiber_octo_pa',
    img: 'https://cdn.shopify.com/s/files/1/0570/3483/4103/files/octo-maxgrip-fiber-clear.webp?width=144',
    video: 'https://www.fiberoficial.com.br/cdn/shop/videos/c/vp/d047a604c9e5468da463ce118552c404/d047a604c9e5468da463ce118552c404.SD-480p-1.5Mbps-34839765.mp4?v=0'
  };

  /* ===== Registro central de modais — garante UM popup por vez =====
     Bootstrap idempotente e duplicado em fiber-popup.js (boas-vindas/exit-intent): quem carregar
     primeiro cria o registro, os dois usam o mesmo. Prioridade maior derruba a menor; prioridade
     menor não abre por cima e pode esperar a fila esvaziar com whenFree(). */
  (function () {
    if (window.FiberModals) return;
    var current = null, waiters = [];
    function flush() { var w = waiters; waiters = []; w.forEach(function (fn) { try { fn(); } catch (e) {} }); }
    window.FiberModals = {
      isOpen: function () { return !!current; },
      name: function () { return current && current.name; },
      // Tenta abrir. false = já existe um modal igual ou mais importante na tela.
      open: function (name, priority, closeFn) {
        if (current) {
          if (priority <= current.priority) return false;
          var prev = current; current = null;
          try { prev.close(); } catch (e) {}
        }
        current = { name: name, priority: priority, close: closeFn || function () {} };
        document.documentElement.setAttribute('data-fiber-modal', name);
        return true;
      },
      close: function (name) {
        if (!current || (name && current.name !== name)) return;
        current = null;
        document.documentElement.removeAttribute('data-fiber-modal');
        flush();
      },
      whenFree: function (cb) { if (!current) { cb(); return; } waiters.push(cb); }
    };
  })();
  var MODAL_PRIO = { fit: 30, octo: 20, welcome: 10 };

  // Aviso de calce: aparece ANTES de adicionar (segura o clique no botão) e some de vez depois
  // que o produto entra no carrinho de fato — o "ok" fica em localStorage por produto.
  var FIT_NOTICES = {
    9039608512729: {
      handle: 'tenis-barefoot-ultra',
      title: 'Recomendação de tamanho',
      text: 'O Barefoot Ultra possui espaço frontal pensado para o movimento natural dos dedos. Se você prefere um calce mais ajustado, recomendamos um número menor.',
      sizeChart: '/pages/tabela-de-tamanho-barefoot-ultra',
      compare: [
        {
          src: 'https://cdn.shopify.com/s/files/1/0570/3483/4103/files/fiber-calce-com-folga-v3.png?v=1785851693&width=340',
          label: 'Sua numeração',
          caption: 'Mais espaço frontal — o calce natural do barefoot.'
        },
        {
          src: 'https://cdn.shopify.com/s/files/1/0570/3483/4103/files/fiber-calce-ajustado-v3.png?v=1785851693&width=340',
          label: 'Numeração menor',
          caption: 'Calce mais ajustado — dedos junto à borda da palmilha.'
        }
      ]
    }
  };

  function log() { if (window.location.search.indexOf('fiber_debug') > -1) console.log.apply(console, ['[fiber-upsell]'].concat([].slice.call(arguments))); }

  function fetchJSON(url, opts) {
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, FETCH_TIMEOUT);
    return fetch(url, Object.assign({ signal: ctrl.signal }, opts || {}))
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url); return r.json(); })
      .finally(function () { clearTimeout(t); });
  }

  function money(v) { return 'R$ ' + Number(v).toFixed(2).replace('.', ','); }

  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }

  // Adiciona itens via AJAX e atualiza/abre o cart drawer do Prestige
  function addToCart(items, source) {
    internalAdd = true;
    items.forEach(function (i) { i.properties = Object.assign({}, i.properties, { _reco_source: source }); });
    return fetchJSON(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return fetchJSON('/cart.js').then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function' && !drawer.open) { try { drawer.show(); } catch (e) {} }
        setTimeout(function () { internalAdd = false; }, 1500);
        return res;
      });
    }).catch(function (e) { internalAdd = false; throw e; });
  }

  // Busca variantes de um produto pelo handle; devolve {variants, needsPicker}
  function getVariants(handle) {
    return fetchJSON('/products/' + handle + '.js').then(function (p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      return { product: p, variants: avail, needsPicker: avail.length > 1 };
    });
  }

  function variantPickerHtml(variants, cls) {
    return '<select class="' + cls + '" aria-label="Escolha a variante">' + variants.map(function (v) {
      return '<option value="' + v.id + '" data-price="' + (v.price / 100) + '">' + escapeHtml(v.title === 'Default Title' ? 'Único' : v.title) + '</option>';
    }).join('') + '</select>';
  }

  /* ================= CUPOM DO COMBO (anti-empilhamento) ================= */
  // Prefixos que identificam um cupom do Compre Junto (dinâmico ou estático legado).
  var CJ_CODE_RE = /^(CJ10-|CJ14-|COMPREJUNTO10|COMPREJUNTO14)/i;

  function cartCoupons(cart) {
    var apps = (cart && cart.cart_level_discount_applications) || [];
    return apps.map(function (d) { return String((d && (d.title || d.code)) || ''); })
               .filter(Boolean);
  }

  function comboCoupons(cart) {
    return cartCoupons(cart).filter(function (code) { return CJ_CODE_RE.test(code); });
  }

  function otherCoupons(cart) {
    return cartCoupons(cart).filter(function (code) { return !CJ_CODE_RE.test(code); });
  }

  // faixa do código: CJ14-/COMPREJUNTO14 => 14, CJ10-/COMPREJUNTO10 => 10
  function couponTier(code) {
    var m = String(code || '').match(/1[04]/);
    return m ? Number(m[0]) : 0;
  }

  function maxTier(codes) {
    return codes.reduce(function (acc, c) { return Math.max(acc, couponTier(c)); }, 0);
  }

  // Remove TODOS os códigos do carrinho (a Ajax API não remove um a um).
  // Só é chamado quando o carrinho tem exclusivamente cupom de combo.
  function clearCartDiscounts() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () { return true; }).catch(function () { return false; });
  }

  // Falha de cupom não pode ser silenciosa: venda acontece e a medição não.
  function reportCouponIssue(reason, code, detail) {
    var payload = { reason: reason, code: code, detail: detail || null, at: new Date().toISOString() };
    try {
      window.FiberReco = window.FiberReco || {};
      window.FiberReco.couponIssues = window.FiberReco.couponIssues || [];
      window.FiberReco.couponIssues.push(payload);
      if (typeof window.FiberReco.track === 'function') window.FiberReco.track('coupon_issue', payload);
    } catch (e) { /* noop */ }
    console.warn('[fiber-upsell] cupom do combo:', reason, code, detail || '');
  }

  // Aplica o cupom do combo com trava: só quando NÃO existe outro CJ no carrinho,
  // e confirma no /cart.js se realmente entrou.
  function applyComboCoupon(code) {
    return fetchJSON('/cart.js')
      .then(function (cart) {
        var outros = otherCoupons(cart);
        if (outros.length) {
          // cupom do cliente (afiliado/campanha) tem prioridade e não pode ser removido
          reportCouponIssue('skipped_other_coupon', code, outros);
          return { applied: false, skipped: true };
        }

        var atuais = comboCoupons(cart);
        if (atuais.length) {
          if (couponTier(code) <= maxTier(atuais)) {
            reportCouponIssue('skipped_same_or_lower_tier', code, atuais);
            return { applied: false, skipped: true };
          }
          // faixa maior: troca (remove o antigo) em vez de somar
          log('upgrade de faixa do combo', atuais, '->', code);
          return clearCartDiscounts().then(function () { return doApply(code); });
        }

        return doApply(code);
      })
      .catch(function (err) {
        reportCouponIssue('error', code, String(err && err.message));
        return { applied: false };
      });
  }

  function doApply(code) {
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return fetchJSON('/cart.js'); })
      .then(function (after) {
        var wanted = String(code).toUpperCase();
        var applied = cartCoupons(after).some(function (c) { return c.toUpperCase() === wanted; });
        if (!applied) reportCouponIssue('not_applied', code, cartCoupons(after));
        else log('cupom do combo aplicado', code);
        return { applied: applied };
      })
      .catch(function (err) {
        reportCouponIssue('error', code, String(err && err.message));
        return { applied: false };
      });
  }

  /* ================= COMPRE JUNTO (PDP) ================= */
  function initCompreJunto() {
    var el = document.getElementById('fiber-compre-junto');
    if (!el || el.dataset.init) return;
    el.dataset.init = '1';
    var anchorPid = el.dataset.productId;
    var anchorTitle = el.dataset.productTitle;
    var anchorImg = el.dataset.productImage;
    var anchorPrice = Number(el.dataset.productPrice) / 100;
    var anchorCompare = Number(el.dataset.productCompare || 0) / 100;

    fetchJSON(API + anchorPid + '?limit=4').then(function (data) {
      var recos = (data.items || []).filter(function (i) { return i.available; }).slice(0, 2);
      if (!recos.length) { log('sem recos p/', anchorPid); return; }
      return Promise.all(recos.map(function (r) { return getVariants(r.handle).catch(function () { return null; }); })).then(function (vs) {
        var rows = [];
        recos.forEach(function (r, idx) {
          if (!vs[idx] || !vs[idx].variants.length) return;
          rows.push({ reco: r, vinfo: vs[idx] });
        });
        if (!rows.length) return;
        render(rows);
      });
    }).catch(function (e) { log('erro compre-junto', e); });

    function render(rows) {
      var itemsHtml = '<div class="fiber-cj__item" data-role="anchor">' +
        '<input type="checkbox" class="fiber-cj__check" checked disabled aria-label="Este produto">' +
        '<img class="fiber-cj__thumb" src="' + anchorImg + '" alt="" width="56" height="56" loading="lazy">' +
        '<div class="fiber-cj__info"><p class="fiber-cj__name"><span class="fiber-cj__this">Este produto:</span> ' + escapeHtml(anchorTitle) + '</p>' +
        '<div class="fiber-cj__prices"><span class="fiber-cj__price">' + money(anchorPrice) + '</span>' +
        (anchorCompare > anchorPrice ? '<span class="fiber-cj__compare">' + money(anchorCompare) + '</span>' : '') +
        '</div></div></div>';

      rows.forEach(function (row, i) {
        var r = row.reco, v = row.vinfo;
        itemsHtml += '<div class="fiber-cj__plus">+</div>' +
          '<div class="fiber-cj__item" data-role="reco" data-idx="' + i + '" data-price="' + r.price_min + '" data-compare="' + (r.compare_at_price || 0) + '">' +
          '<input type="checkbox" class="fiber-cj__check" checked aria-label="Adicionar ' + escapeHtml(r.title) + '">' +
          '<img class="fiber-cj__thumb" src="' + r.image + '" alt="" width="56" height="56" loading="lazy">' +
          '<div class="fiber-cj__info"><p class="fiber-cj__name">' + escapeHtml(r.title) + '</p>' +
          '<div class="fiber-cj__prices"><span class="fiber-cj__price">' + money(r.price_min) + '</span>' +
          (r.compare_at_price > r.price_min ? '<span class="fiber-cj__compare">' + money(r.compare_at_price) + '</span>' : '') +
          '</div>' + (v.needsPicker ? variantPickerHtml(v.variants, 'fiber-cj__variant') : '<input type="hidden" class="fiber-cj__variant-hidden" value="' + v.variants[0].id + '">') +
          '</div></div>';
      });

      el.querySelector('[data-cj-items]').innerHTML = itemsHtml;
      el.hidden = false;
      update();
      el.addEventListener('change', update);
      el.querySelector('[data-cj-add]').addEventListener('click', onAdd);

      // âncora acompanha a variante selecionada na PDP (imagem/preço/variant id)
      document.addEventListener('variant:change', function (ev) {
        var det = ev.detail || {};
        if (!det.variant || !det.product || String(det.product.id) !== String(anchorPid)) return;
        var v = det.variant;
        anchorPrice = v.price / 100;
        anchorCompare = (v.compare_at_price || 0) / 100;
        el.dataset.variantId = v.id;
        var row = el.querySelector('.fiber-cj__item[data-role=anchor]');
        if (row) {
          var img = row.querySelector('.fiber-cj__thumb');
          var src = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src;
          if (img && src) img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=112';
          var prices = row.querySelector('.fiber-cj__prices');
          if (prices) prices.innerHTML = '<span class="fiber-cj__price">' + money(anchorPrice) + '</span>' +
            (anchorCompare > anchorPrice ? '<span class="fiber-cj__compare">' + money(anchorCompare) + '</span>' : '');
        }
        update();
      });
    }

    function selectedRecoRows() {
      return [].slice.call(el.querySelectorAll('.fiber-cj__item[data-role=reco]')).filter(function (row) {
        return row.querySelector('.fiber-cj__check').checked;
      });
    }

    function update() {
      var rows = selectedRecoRows();
      var total = anchorPrice, compare = Math.max(anchorCompare, anchorPrice);
      rows.forEach(function (row) {
        var sel = row.querySelector('select.fiber-cj__variant');
        var price = sel ? Number(sel.options[sel.selectedIndex].dataset.price) : Number(row.dataset.price);
        total += price;
        compare += Math.max(Number(row.dataset.compare) || 0, price);
      });
      var n = rows.length + 1;
      var cupom = COMBO_CUPONS[rows.length];
      var totalComCupom = cupom ? total * (1 - cupom.pct) : total;
      var save = compare - totalComCupom;
      // preço unitário exibido acompanha o cupom do combo: desmarcou tudo, volta ao cheio
      var pct = cupom ? cupom.pct : 0;
      function priceHtml(price, cmp) {
        var fin = price * (1 - pct);
        var full = Math.max(Number(cmp) || 0, price);
        return '<span class="fiber-cj__price">' + money(fin) + '</span>' +
          (full > fin + 0.009 ? '<span class="fiber-cj__compare">' + money(full) + '</span>' : '');
      }
      var anchorRow = el.querySelector('.fiber-cj__item[data-role=anchor] .fiber-cj__prices');
      if (anchorRow) anchorRow.innerHTML = priceHtml(anchorPrice, anchorCompare);
      [].slice.call(el.querySelectorAll('.fiber-cj__item[data-role=reco]')).forEach(function (row) {
        var box = row.querySelector('.fiber-cj__prices');
        if (!box) return;
        var sel = row.querySelector('select.fiber-cj__variant');
        var price = sel ? Number(sel.options[sel.selectedIndex].dataset.price) : Number(row.dataset.price);
        var marcado = row.querySelector('.fiber-cj__check').checked;
        box.innerHTML = marcado ? priceHtml(price, row.dataset.compare) :
          '<span class="fiber-cj__price">' + money(price) + '</span>' +
          (Number(row.dataset.compare) > price ? '<span class="fiber-cj__compare">' + money(Number(row.dataset.compare)) + '</span>' : '');
      });
      el.querySelector('[data-cj-total]').innerHTML =
        '<div class="fiber-cj__totalrow"><span class="fiber-cj__totallabel">Total (' + n + ' ' + (n > 1 ? 'itens' : 'item') + ')</span>' +
        '<span class="fiber-cj__totalvals">' + (save > 0.009 ? '<span class="fiber-cj__totalcompare">' + money(compare) + '</span>' : '') +
        '<span class="fiber-cj__total">' + money(totalComCupom) + '</span></span></div>' +
        (cupom ? '<span class="fiber-cj__save">' + Math.round(cupom.pct * 100) + '% OFF no combo aplicado (' + (save > 0.009 ? 'economize ' + money(save) : cupom.code) + ')</span>' : '') +
        '<span class="fiber-cj__hint">Leve +1 item: 10% OFF &nbsp;·&nbsp; leve +2 itens: 14% OFF</span>';
      el.querySelector('.fiber-cj__btnlabel').textContent = n > 1 ? 'Adicionar os ' + n + ' ao carrinho' : 'Adicionar ao carrinho';
      [].slice.call(el.querySelectorAll('.fiber-cj__item[data-role=reco]')).forEach(function (row) {
        row.classList.toggle('fiber-cj__item--off', !row.querySelector('.fiber-cj__check').checked);
      });
    }

    function onAdd() {
      var btn = el.querySelector('[data-cj-add]');
      // form da PDP tem id "product-form-{productId}-{sectionId}" — nunca pegar quick-buy do drawer
      var form = document.querySelector('form[id^="product-form-' + anchorPid + '"] input[name="id"]') ||
                 document.querySelector('.product-info form[action*="/cart/add"] input[name="id"]');
      var anchorVariant = form ? form.value : el.dataset.variantId;
      var items = [{ id: Number(anchorVariant), quantity: 1, properties: { _cj_anchor: String(anchorPid) } }];
      var recoRows = selectedRecoRows();
      recoRows.forEach(function (row) {
        var sel = row.querySelector('select.fiber-cj__variant') || row.querySelector('.fiber-cj__variant-hidden');
        items.push({ id: Number(sel.value), quantity: 1, properties: { _cj_anchor: String(anchorPid) } });
      });
      var cupom = COMBO_CUPONS[recoRows.length];
      btn.classList.add('is-loading'); btn.disabled = true;
      addToCart(items, 'fiber-compre-junto').then(function () {
        // aplica o cupom dinâmico do combo (CJ10-/CJ14-{âncora}) — rastreável por produto no
        // pedido. applyComboCoupon garante 1 CJ por carrinho e confirma que entrou.
        if (cupom) return applyComboCoupon(cupom.dyn + anchorPid);
      }).then(function () {
        btn.classList.remove('is-loading'); btn.disabled = false;
      }).catch(function (e) {
        btn.classList.remove('is-loading'); btn.disabled = false;
        log('erro add', e);
        alert('Não foi possível adicionar. Tente novamente.');
      });
    }
  }

  /* ================= AVISO DE CALCE (gate pré-add) =================
     Segura o clique em "Adicionar ao carrinho", mostra o aviso e só adiciona quando a pessoa
     confirma no popup. Depois que o item entra no carrinho de verdade (evento variant:add),
     o aviso é marcado como visto e não aparece mais — fechar no ✕/Esc NÃO marca. */
  var FIT_ACK_PREFIX = 'fiber_fit_ok_';
  var fitBypass = false;      // libera o clique re-disparado pelo próprio popup
  var pendingFitPid = null;   // add liberado pelo aviso, aguardando confirmação no variant:add

  // 1x por SESSÃO por produto (sessionStorage): confirmou, não repete até a próxima visita.
  function fitAcked(pid) { try { return !!sessionStorage.getItem(FIT_ACK_PREFIX + pid); } catch (e) { return false; } }
  function ackFit(pid) { try { sessionStorage.setItem(FIT_ACK_PREFIX + pid, '1'); } catch (e) {} }

  // Instrumentação obrigatória (GTM/dataLayer + GA4 gtag + evento de DOM p/ quem quiser ouvir).
  function trackFit(evento, dados) {
    var payload = Object.assign({ event: evento }, dados || {});
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', evento, dados || {}); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent(evento, { detail: dados || {} })); } catch (e) {}
    log('evento', evento, dados);
  }

  // Id do produto do formulário de add — várias fontes porque o tema muda de seção p/ seção.
  function productIdOf(form) {
    var el = form.closest('[data-product-id]');
    if (el) return Number(el.getAttribute('data-product-id')) || null;
    var inp = form.querySelector('input[name="product-id"], input[name="product_id"]');
    if (inp && inp.value) return Number(inp.value) || null;
    var json = form.closest('.product-info, .shopify-section') ;
    if (json) {
      var tag = json.querySelector('script[type="application/json"][data-product-json], script[data-product-json]');
      if (tag) { try { var p = JSON.parse(tag.textContent); if (p && p.id) return Number(p.id); } catch (e) {} }
    }
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        return Number(ShopifyAnalytics.meta.product.id) || null;
      }
    } catch (e) {}
    return null;
  }

  function initFitGate() {
    // v1.10.0 trocou localStorage por sessionStorage: apaga o marcador permanente das versões
    // anteriores, senão quem confirmou antes nunca mais veria o aviso.
    Object.keys(FIT_NOTICES).forEach(function (id) {
      try { localStorage.removeItem(FIT_ACK_PREFIX + id); } catch (e) {}
    });

    // PDP de produto com aviso: já busca o catálogo agora, p/ o popup abrir com os números prontos
    var pdp = document.querySelector('[data-product-id]');
    var pdpId = pdp && Number(pdp.getAttribute('data-product-id'));
    if (pdpId && FIT_NOTICES[pdpId] && FIT_NOTICES[pdpId].handle) {
      productJson(FIT_NOTICES[pdpId].handle).catch(function (e) { log('prefetch catálogo falhou', e); });
    }

    // captura: roda antes do handler do tema, então dá p/ cancelar o add
    document.addEventListener('click', function (ev) {
      if (fitBypass) return;
      var el = ev.target && ev.target.closest ? ev.target.closest('button, input[type="submit"], [data-add-to-cart]') : null;
      if (!el || el.disabled) return;
      var form = el.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (el.type && el.type !== 'submit' && !el.hasAttribute('data-add-to-cart') && el.name !== 'add') return;
      var pid = productIdOf(form);
      if (!pid) return;
      var notice = FIT_NOTICES[pid];
      if (!notice || fitAcked(pid)) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      showFitGate(notice, pid, el, form);
    }, true);
  }

  // Catálogo do produto com cache + 1 nova tentativa: a loja responde 429 quando a chamada sai
  // no mesmo instante do clique, e sem esses dados o popup perde os números.
  var productCache = {};
  function productJson(handle) {
    if (productCache[handle]) return productCache[handle];
    var url = '/products/' + handle + '.js';
    var pr = fetchJSON(url).catch(function () {
      return new Promise(function (r) { setTimeout(r, 800); }).then(function () { return fetchJSON(url); });
    }).catch(function (e) {
      delete productCache[handle]; // deixa tentar de novo no próximo clique
      throw e;
    });
    productCache[handle] = pr;
    return pr;
  }

  // Tamanho selecionado + o número imediatamente menor disponível na MESMA cor.
  // Devolve {atual, menor, menorVariantId} — menor = null quando não existe/está esgotado.
  function sizeContext(notice, form) {
    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput && Number(idInput.value);
    if (!variantId || !notice.handle) return Promise.resolve(null);
    return productJson(notice.handle).then(function (p) {
      var atual = null;
      p.variants.forEach(function (v) { if (v.id === variantId) atual = v; });
      if (!atual) return null;
      // índice da opção de tamanho: a que tem valores numéricos
      var idx = -1;
      for (var i = 0; i < atual.options.length; i++) {
        if (/^\d{2}$/.test(String(atual.options[i]).trim())) { idx = i; break; }
      }
      if (idx === -1) return null;
      var num = parseInt(atual.options[idx], 10);
      if (!num) return null;
      var alvo = String(num - 1);
      var menor = null;
      p.variants.forEach(function (v) {
        if (menor || !v.available) return;
        if (String(v.options[idx]).trim() !== alvo) return;
        for (var j = 0; j < v.options.length; j++) { if (j !== idx && v.options[j] !== atual.options[j]) return; }
        menor = v;
      });
      return {
        optionName: p.options[idx] && (p.options[idx].name || p.options[idx]),
        optionIndex: idx,
        atual: String(num),
        menor: menor ? alvo : null
      };
    }).catch(function (e) { log('sizeContext falhou', e); return null; });
  }

  // "Quero trocar o tamanho": devolve a pessoa ao seletor de numeração da página.
  function focusSizePicker(ctx) {
    var nome = 'option' + ((ctx && ctx.optionIndex != null ? ctx.optionIndex : 0) + 1);
    var radios = document.querySelectorAll('.product-info input[type="radio"][name="' + nome + '"]');
    var alvo = null;
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) { alvo = radios[i]; break; } }
    if (!alvo) alvo = radios[0];
    if (!alvo) return false;
    var lbl = document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(alvo.id) : alvo.id) + '"]');
    try { (lbl || alvo).scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
    try { alvo.focus({ preventScroll: true }); } catch (e) { try { alvo.focus(); } catch (e2) {} }
    return true;
  }

  function showFitGate(notice, pid, addBtn, form) {
    var old = document.getElementById('fiber-fit-overlay');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.id = 'fiber-fit-overlay';
    wrap.className = 'fiber-pa-overlay';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', notice.title);
    var cmp = notice.compare || [];
    wrap.innerHTML =
      '<div class="fiber-pa fiber-pa--fit">' +
        '<button type="button" class="fiber-pa__close" aria-label="Fechar">✕</button>' +
        '<div class="fiber-pa__body">' +
          '<div class="fiber-pa__header">' +
            '<h2 class="fiber-pa__title">' + escapeHtml(notice.title) + '</h2>' +
            '<p class="fiber-pa__hook">' + escapeHtml(notice.text) + '</p>' +
          '</div>' +
          (cmp.length === 2 ?
            '<div class="fiber-fit__compare">' +
              cmp.map(function (c, i) {
                return '<figure class="fiber-fit__opt' + (i === 0 ? ' is-rec' : '') + '">' +
                  '<img src="' + c.src + '" alt="' + escapeHtml(c.caption) + '" loading="eager" width="170" height="163">' +
                  '<figcaption>' +
                    '<strong>' + escapeHtml(c.label) + '</strong>' +
                    '<span class="fiber-fit__size" data-fit-size="' + i + '"></span>' +
                    '<span class="fiber-fit__cap">' + escapeHtml(c.caption) + '</span>' +
                  '</figcaption>' +
                '</figure>';
              }).join('') +
            '</div>' : '') +
          '<label class="fiber-fit__check">' +
            '<input type="checkbox" class="fiber-fit__checkbox">' +
            '<span>Li e confirmo o tamanho que escolhi</span>' +
          '</label>' +
          '<button type="button" class="fiber-pa__cta" disabled aria-disabled="true"><span class="fiber-pa__ctalabel">Confirmar e continuar</span></button>' +
          '<button type="button" class="fiber-fit__change">Quero trocar o tamanho</button>' +
          '<p class="fiber-fit__note" hidden></p>' +
          (notice.sizeChart ? '<a class="fiber-pa__chart" href="' + notice.sizeChart + '">Ver tabela de tamanhos</a>' : '') +
        '</div>' +
      '</div>';

    var ctxAtual = null;
    var eventoBase = { product_id: pid, product_handle: notice.handle || '' };
    function dadosEvento(extra) {
      return Object.assign({}, eventoBase, {
        tamanho: ctxAtual ? ctxAtual.atual : '',
        tamanho_menor: ctxAtual ? (ctxAtual.menor || '') : ''
      }, extra || {});
    }

    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      wrap.classList.remove('is-visible');
      document.removeEventListener('keydown', onEsc);
      setTimeout(function () { wrap.remove(); }, 350);
      window.FiberModals.close('fit');
    }
    function onEsc(e) { if (e.key === 'Escape') close(); }

    // gate é o modal mais importante: se algo estiver aberto (boas-vindas, upsell), fecha
    window.FiberModals.open('fit', MODAL_PRIO.fit, close);
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('is-visible'); }); });

    wrap.querySelector('.fiber-pa__close').addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.addEventListener('keydown', onEsc);
    // add pelo caminho normal do tema (mantém a variante escolhida na página)
    function confirmarAdd() {
      pendingFitPid = pid;          // ack só quando o variant:add confirmar
      fitBypass = true;             // deixa o clique passar direto agora
      close();
      try { addBtn.click(); } finally { setTimeout(function () { fitBypass = false; }, 2000); }
    }

    var btnAdd = wrap.querySelector('.fiber-pa__cta');
    var btnTrocar = wrap.querySelector('.fiber-fit__change');
    var check = wrap.querySelector('.fiber-fit__checkbox');
    var nota = wrap.querySelector('.fiber-fit__note');

    // checkbox trava o avanço (aceite de termos)
    check.addEventListener('change', function () {
      btnAdd.disabled = !check.checked;
      btnAdd.setAttribute('aria-disabled', String(!check.checked));
    });
    btnAdd.addEventListener('click', function () {
      if (!check.checked) { check.focus(); return; }
      trackFit('fiber_size_confirmed', dadosEvento());
      confirmarAdd();
    });
    btnTrocar.addEventListener('click', function () {
      trackFit('fiber_size_change_requested', dadosEvento());
      close();
      focusSizePicker(ctxAtual); // não adiciona nada: volta pro seletor de numeração
    });
    setTimeout(function () { try { check.focus(); } catch (e) {} }, 120);

    // o "exibido" espera os números do catálogo p/ sair com o tamanho — sem isso não dá p/ ver
    // quais numerações mais disparam o aviso. Se o catálogo demorar, sai assim mesmo.
    var shownEnviado = false;
    function dispararShown() {
      if (shownEnviado) return;
      shownEnviado = true;
      trackFit('fiber_size_modal_shown', dadosEvento());
    }
    setTimeout(dispararShown, 1500);

    // completa com os números assim que o catálogo responde (popup já está na tela)
    if (form) sizeContext(notice, form).then(function (ctx) {
      if (closed || !ctx) { dispararShown(); return; } // sem catálogo o popup segue funcional
      ctxAtual = ctx;
      dispararShown();
      var tags = wrap.querySelectorAll('[data-fit-size]');
      if (tags[0]) tags[0].textContent = 'Tamanho ' + ctx.atual;
      if (tags[1]) tags[1].textContent = ctx.menor ? 'Tamanho ' + ctx.menor : 'Um número abaixo';
      if (!ctx.menor) {
        nota.textContent = 'O número menor está esgotado nesta cor.';
        nota.hidden = false;
      }
    });
  }

  /* ================= MODAL PÓS-ADD ================= */
  function initPostAdd() {
    document.addEventListener('variant:add', function (ev) {
      if (internalAdd) return;
      var items = ev.detail && ev.detail.items;
      if (!items || !items.length) return;
      var pid = items[0].product_id;
      if (!pid) return;
      // add liberado pelo aviso de calce: marca como visto e não abre upsell no mesmo clique
      if (pendingFitPid && String(pendingFitPid) === String(pid)) {
        ackFit(pid); pendingFitPid = null; return;
      }
      maybeOctoOffer(pid); // popup pós-add é EXCLUSIVO da oferta Octo Clear (sem fallback reco)
    });

    // Oferta prioritária: Octo Clear 40% OFF. Resolve true se o modal foi exibido.
    function maybeOctoOffer(pid) {
      if (String(pid) === String(OCTO.pid)) return Promise.resolve(false);
      try { if (sessionStorage.getItem(OCTO.capKey)) return Promise.resolve(false); } catch (e) {}
      return fetchJSON('/cart.js').then(function (cart) {
        var inCart = cart.items.some(function (i) { return i.variant_id === OCTO.variantId; });
        if (inCart) return false;
        return fetchJSON('/products/' + OCTO.handle + '.js').then(function (p) {
          var v = null;
          p.variants.forEach(function (x) { if (x.id === OCTO.variantId) v = x; });
          if (!v || !v.available) return false;
          if (!v.compare_at_price || v.compare_at_price <= v.price) return false; // sem "valor cheio" p/ riscar → não oferta
          var img = (v.featured_image && v.featured_image.src) || OCTO.img;
          try { sessionStorage.setItem(OCTO.capKey, '1'); } catch (e) {}
          setTimeout(function () { showOctoModal(v, img); }, 700);
          return true;
        });
      }).catch(function (e) { log('erro octo-offer', e); return false; });
    }

    function showOctoModal(variant, imgSrc) {
      var promo = variant.price / 100;
      var cheio = (variant.compare_at_price || 0) / 100;
      if (cheio <= promo) { log('sem compare_at > preço; popup suprimido'); return; }
      var pctOff = Math.round((1 - promo / cheio) * 100);
      var pdpUrl = '/products/' + OCTO.handle + '?variant=' + OCTO.variantId;
      var old = document.getElementById('fiber-postadd-overlay');
      if (old) old.remove();
      var wrap = document.createElement('div');
      wrap.id = 'fiber-postadd-overlay';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.setAttribute('aria-label', 'Oferta especial Octo MaxGrip Clear');
      // Layout espelhando o popup padrão do tema (#fiber-popup-container): mídia full-width no topo,
      // botão de fechar circular flutuante, corpo centralizado (título + subtítulo), CTA vermelha
      // full-width e nota pequena embaixo.
      wrap.innerHTML =
        '<div class="fiber-pa fiber-pa--octo">' +
          '<button type="button" class="fiber-pa__close" aria-label="Fechar">✕</button>' +
          '<a class="fiber-pa__medialink" href="' + pdpUrl + '" aria-label="Ver Octo MaxGrip Clear">' +
            '<video class="fiber-pa__video" src="' + OCTO.video + '" poster="' + imgSrc + '" autoplay muted loop playsinline preload="metadata"></video>' +
          '</a>' +
          '<div class="fiber-pa__body">' +
            '<div class="fiber-pa__header">' +
              '<h2 class="fiber-pa__title">Leve também com ' + pctOff + '% OFF</h2>' +
              '<p class="fiber-pa__hook">Quem leva esse produto costuma levar também o Octo MaxGrip Clear.</p>' +
            '</div>' +
            '<div class="fiber-pa__offer">' +
              '<a class="fiber-pa__namelink" href="' + pdpUrl + '"><p class="fiber-pa__name">Octo MaxGrip — Clear</p></a>' +
              '<div class="fiber-pa__prices">' +
                '<span class="fiber-pa__price">' + money(promo) + '</span>' +
                '<span class="fiber-pa__compare">' + money(cheio) + '</span>' +
                '<span class="fiber-pa__offbadge">-' + pctOff + '%</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="fiber-pa__cta"><span class="fiber-cj__spinner"></span><span class="fiber-pa__ctalabel">Quero com ' + pctOff + '% OFF</span></button>' +
            '<p class="fiber-pa__note">Condição exclusiva desta oferta — garanta antes que volte a ' + money(cheio) + '.</p>' +
            '<button type="button" class="fiber-pa__skip">Não, obrigado</button>' +
          '</div>' +
        '</div>';
      // substitui o popup de boas-vindas (menos importante), mas nunca o aviso de tamanho
      if (!window.FiberModals.open('octo', MODAL_PRIO.octo, function () { close(); })) {
        log('modal mais importante na tela; upsell suprimido'); return;
      }
      document.body.appendChild(wrap);
      requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('is-visible'); }); });

      // autoplay garantido (atributo via innerHTML às vezes não basta)
      var vid = wrap.querySelector('.fiber-pa__video');
      if (vid) { vid.muted = true; var pp = vid.play(); if (pp && pp.catch) pp.catch(function () {}); }

      var octoClosed = false;
      function close() {
        if (octoClosed) return;
        octoClosed = true;
        wrap.classList.remove('is-visible');
        setTimeout(function () { wrap.remove(); }, 350);
        window.FiberModals.close('octo');
      }
      wrap.querySelector('.fiber-pa__close').addEventListener('click', close);
      wrap.querySelector('.fiber-pa__skip').addEventListener('click', close);
      wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
      document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
      wrap.querySelector('.fiber-pa__cta').addEventListener('click', function () {
        var btn = this;
        btn.classList.add('is-loading'); btn.disabled = true;
        addToCart([{ id: OCTO.variantId, quantity: 1 }], 'fiber-octo-popup').then(close).catch(function () {
          btn.classList.remove('is-loading'); btn.disabled = false;
          alert('Não foi possível adicionar. Tente novamente.');
        });
      });
    }
  }

  function init() { initFitGate(); initCompreJunto(); initPostAdd(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

